import React, { useState, useEffect } from 'react';
import { Container, Table, Badge, Button, Modal } from 'react-bootstrap';
import applicationService from '../../services/applicationService';

const ApplicationsManagePage = () => {
  const [applications, setApplications] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedApplication, setSelectedApplication] = useState(null);

  useEffect(() => {
    loadApplications();
  }, []);

  const loadApplications = async () => {
    try {
      const data = await applicationService.getApplications();
      setApplications(data);
    } catch (error) {
      console.error('Failed to load applications:', error);
    }
  };

  const handleViewDetails = (application) => {
    setSelectedApplication(application);
    setShowModal(true);
  };

  const handleStatusUpdate = async (id, newStatus) => {
    try {
      await applicationService.updateApplicationStatus(id, newStatus);
      loadApplications(); // Reload the list after update
      setShowModal(false);
    } catch (error) {
      console.error('Failed to update status:', error);
    }
  };

  const getStatusBadge = (status) => {
    const variants = {
      pending: 'warning',
      accepted: 'success',
      rejected: 'danger',
      interviewing: 'info'
    };
    return <Badge bg={variants[status]}>{status}</Badge>;
  };

  return (
    <Container fluid>
      <h2 className="mb-4">Job Applications</h2>
      
      <Table responsive striped hover>
        <thead>
          <tr>
            <th>Name</th>
            <th>Position</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Applied Date</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {applications.map(application => (
            <tr key={application.id}>
              <td>{application.full_name}</td>
              <td>{application.position}</td>
              <td>{application.email}</td>
              <td>{application.phone}</td>
              <td>{application.appliedAt}</td>
              <td>{getStatusBadge(application.status)}</td>
              <td>
                <Button 
                  variant="outline-primary" 
                  size="sm"
                  onClick={() => handleViewDetails(application)}
                >
                  View Details
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Application Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedApplication && (
            <div>
              <h4>{selectedApplication.fullName}</h4>
              <p><strong>Position:</strong> {selectedApplication.position}</p>
              <p><strong>Email:</strong> {selectedApplication.email}</p>
              <p><strong>Phone:</strong> {selectedApplication.phone}</p>
              <p><strong>Applied Date:</strong> {selectedApplication.appliedAt}</p>
              <p><strong>Current Status:</strong> {getStatusBadge(selectedApplication.status)}</p>
              
              <div className="mt-4">
                <h5>Update Status</h5>
                <div className="d-flex gap-2">
                  <Button 
                    variant="warning" 
                    onClick={() => handleStatusUpdate(selectedApplication.id, 'interviewing')}
                  >
                    Mark as Interviewing
                  </Button>
                  <Button 
                    variant="success" 
                    onClick={() => handleStatusUpdate(selectedApplication.id, 'accepted')}
                  >
                    Accept
                  </Button>
                  <Button 
                    variant="danger" 
                    onClick={() => handleStatusUpdate(selectedApplication.id, 'rejected')}
                  >
                    Reject
                  </Button>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default ApplicationsManagePage;